import { TableField } from 'lib/context';
import dayjs from 'dayjs';
import { TFunction } from 'i18next';

export enum HistoryTableColumns {
  DATE = 'dateSent',
  RECIPIENTS = 'email',
  TIME_FRAME = 'dateRange',
  NAME = 'report',
  ACTION = 'action',
}

export const getDetailsTableFields = (t: TFunction): TableField[] => [
  {
    value: HistoryTableColumns.NAME,
    label: t('Report Name'),
    width: 240,
  },
  {
    value: HistoryTableColumns.DATE,
    label: t('Sent Date'),
    sortable: true,
    sortKey: 'DATE',
    width: 280,
  },
  {
    value: HistoryTableColumns.RECIPIENTS,
    label: t('Recipient(s)'),
    width: 400,
  },
  {
    value: HistoryTableColumns.TIME_FRAME,
    label: t('Timeframe'),
    width: 280,
  },
  {
    value: HistoryTableColumns.ACTION,
    label: '',
    height: '100%',
    width: 50,
  },
];

export enum CustomReportsTableColumns {
  REPORT_NAME = 'title',
  TYPE = 'type',
  RECIPIENTS = 'recipients',
  DATE = 'date',
  SYNC = 'sync',
  DELIVERY = 'delivery',
}

export const getCustomReportTableFields = (t: TFunction): TableField[] => [
  {
    value: CustomReportsTableColumns.REPORT_NAME,
    label: t('Report Name'),
    sortable: true,
    sortKey: 'REPORT_NAME',
    width: 170,
    height: '100%',
  },
  {
    value: CustomReportsTableColumns.TYPE,
    label: t('Type'),
    sortable: true,
    width: 105,
    height: '100%',
  },
  {
    value: CustomReportsTableColumns.DELIVERY,
    label: t('Delivery'),
    width: 105,
    height: '100%',
  },
  {
    value: CustomReportsTableColumns.RECIPIENTS,
    label: t('Recipients'),
    width: 270,
  },
  {
    value: CustomReportsTableColumns.DATE,
    label: t('Timeframe'),
    width: 150,
  },
  {
    value: CustomReportsTableColumns.SYNC,
    label: '',
    height: '100%',
  },
];

export const formatCustomReportDate = (value?: string) => {
  if (!value) {
    return new Date();
  }

  return dayjs(value, 'YYYY-MM-DD').toDate();
};
